import { SparklesIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

export default function CasinoPromoCard({
  ctaLabel = "Join Now",
  ctaTo = "/casino",
  className = "",
}) {
  const navigate = useNavigate();

  return (
    <section
      className={`rounded-[20px] bg-[#1d222b] p-3 shadow-[0_24px_70px_rgba(0,0,0,0.24)] ${className}`}
    >
      <div className="grid gap-3 lg:grid-cols-[1.25fr_0.75fr]">
        <div className="relative overflow-hidden rounded-[18px] bg-[radial-gradient(circle_at_left,rgba(31,247,137,0.08),transparent_28%),linear-gradient(135deg,#30343a,#252a31_50%,#252c2c)] p-6">
          <div className="absolute left-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-black/20">
            <SparklesIcon className="h-6 w-6 text-slate-300" />
          </div>
          <div className="max-w-[430px] pl-14">
            <div className="text-3xl font-black text-white">Stay In Play</div>
            <div className="mt-3 text-sm font-semibold leading-7 text-slate-200">
              Sign up and get fast access to casino originals, crash, and live
              betting flows in one dashboard.
            </div>
            <button
              type="button"
              onClick={() => navigate(ctaTo)}
              className="mt-5 rounded-[14px] bg-emerald-500 px-8 py-3 text-sm font-black text-[#07110d] transition hover:bg-emerald-400"
            >
              {ctaLabel}
            </button>
          </div>
          <div className="pointer-events-none absolute -left-8 bottom-[-30px] h-[240px] w-[240px] rounded-full border border-white/10 bg-[radial-gradient(circle_at_35%_35%,rgba(255,255,255,0.16),rgba(0,0,0,0.08)_60%,transparent_70%)] opacity-70" />
        </div>

        <div className="overflow-hidden rounded-[18px] bg-[#242a33] min-h-[220px]">
          <img
            src="/img/banner.webp"
            alt="Promo"
            className="h-full w-full object-cover object-center"
          />
        </div>
      </div>
    </section>
  );
}
